module.exports = __webpack_public_path__ + "img/2.c1469d5d.jpg";